import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { FormTextarea } from '../../../components/form/FormTextarea';
import { Loader } from '../../../components/Loader';

let RegAppsForm = props => {
  const { error, handleSubmit, submitting } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field name="note" type="textarea" label="Замечания" row="4" component={FormTextarea} />

      {error && <strong>{error}</strong>}
      <div>
        {submitting && <Loader />}
        <button name="action" value="decline" className="btn" type="submit" disabled={submitting}>
          Отклонить
        </button>
      </div>
    </form>
  );
};

RegAppsForm = reduxForm({
  form: 'reg-app-admin', // a unique identifier for this form
  enableReinitialize: true
})(RegAppsForm);

RegAppsForm = connect(state => ({
  initialValues: {
    id: state.regApps.currentItem ? state.regApps.currentItem.id : '',
    note: state.regApps.currentItem ? state.regApps.currentItem.note : '',
    status: 1
  }
}))(RegAppsForm);

export default RegAppsForm;
